<template>
  <!-- <d2-container> -->
    <!-- <page-header slot="header" @submit="handleSubmit" ref="header" /> -->
    <page-main :disabled="disabled" :table-data="table" :params="params" :loading="loading" @submit="handleSubmit" />
  <!-- </d2-container> -->
</template>

<script>
// import { getProjectInfoMaterial } from '@api/projectManager/infoMaterial'
export default {
  name: 'project-info-material',
  components: {
    // 'PageHeader': () => import('./components/header/index'),
    'PageMain': () => import('./components/main')
  },
  props: {
    params: {
      default: null,
      type: Object
    },
    disabled: {
      default: true,
      type: Boolean
    },
    autoLoad: {
      default: false,
      type: Boolean
    }
  },
  watch: {
    params: {
      handler () {
        if (this.autoLoad) {
          this.handleSubmit()
        }
      },
      deep: true,
      immediate: true
    }
  },
  data () {
    return {
      table: [],
      loading: false
    }
  },
  methods: {
    load (params) {
      this.handleSubmit(params)
    },
    // 加载表格数据
    handleSubmit (params) {
      this.loading = true
      this.$api.getProjectInfoMaterialApi({
        ...params || this.params
      }).then(res => {
        this.loading = false
        this.table = res.body.data
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
